import * as React from "react";
import { cn } from "@/lib/utils";
import { STATUS_FILTERS, statusCounts } from "../lib/dashboard-filters";
import type { DashboardLineView, DashboardStatusFilter } from "@/types/dashboard.types";

interface Props {
  lines: DashboardLineView[];
  active: DashboardStatusFilter;
  onChange: (f: DashboardStatusFilter) => void;
}

export function StatusFilterPills({ lines, active, onChange }: Props): React.ReactElement {
  const counts = statusCounts(lines);
  return (
    <div
      className="inline-flex flex-wrap items-center gap-0.5 rounded-full border border-border-subtle bg-bg-surface p-[3px]"
      role="group"
      aria-label="Filtrar por situação"
    >
      {STATUS_FILTERS.map((f) => (
        <button
          key={f.id}
          type="button"
          onClick={() => onChange(f.id)}
          aria-pressed={active === f.id}
          className={cn(
            "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[12px] font-medium transition-colors",
            active === f.id
              ? "bg-text-primary text-white"
              : "text-text-secondary hover:text-text-primary"
          )}
        >
          {f.label}{" "}
          <span
            className={cn(
              "font-mono text-[11px]",
              active === f.id ? "text-white/80" : "text-text-tertiary"
            )}
          >
            {counts[f.id]}
          </span>
        </button>
      ))}
    </div>
  );
}
